import React, { useRef } from 'react'
import "./index.css";

const Loader1 = () => {

  return (
    <div class="wrapper">
      <video autoPlay muted loop id="myVideo">
        <source src="https://assets.embibe.com/production/web-assets/videos/AI/loader.mp4" type="video/mp4"/>
      </video>
    </div>
  )
}

export default Loader1
